import { useEffect } from 'react';
import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card';
import { Avatar, AvatarImage, AvatarFallback } from '@/components/ui/avatar';
import { useNavigate } from 'react-router-dom';

export default function AccountSettings({ user }) {
  const navigate = useNavigate();

  if (!user) {
    return (
      <div className="container mx-auto px-4 pt-32 pb-8">
        <Card className="bg-gray-900 border-gray-800 max-w-2xl mx-auto">
          <CardContent className="py-12">
            <p className="text-center text-gray-400">Please login to access account settings.</p>
          </CardContent>
        </Card>
      </div>
    );
  }

  return (
    <div className="container mx-auto px-4 pt-32 pb-8">
      <div className="max-w-2xl mx-auto">
        <h1 className="text-4xl font-bold text-purple-500 mb-8">Account Settings</h1>

        <Card className="bg-gray-900 border-gray-800 mb-6">
          <CardHeader>
            <CardTitle>Discord Account</CardTitle>
          </CardHeader>
          <CardContent>
            <div className="flex items-center space-x-4">
              <Avatar className="h-20 w-20">
                <AvatarImage src={user.avatar} />
                <AvatarFallback>{user.discord_username?.[0] || '?'}</AvatarFallback>
              </Avatar>
              <div>
                <p className="text-xl font-bold">{user.discord_username}</p>
                <p className="text-sm text-gray-400">Discord ID: {user.discord_id}</p>
                <p className="text-sm text-gray-400 mt-1">
                  Joined: {user.created_at ? new Date(user.created_at).toLocaleDateString() : 'N/A'}
                </p>
                {user.is_admin && (
                  <p className="text-sm text-yellow-500 font-semibold mt-1">⭐ Admin Account</p>
                )}
              </div>
            </div>
          </CardContent>
        </Card>

        <Card className="bg-gray-900 border-gray-800">
          <CardHeader>
            <CardTitle>Participation Status</CardTitle>
          </CardHeader>
          <CardContent>
            <div className="p-4 bg-green-900/30 border border-green-700 rounded-lg">
              <p className="text-green-400 font-semibold">✓ You're all set!</p>
              <p className="text-sm text-gray-400 mt-2">
                You can participate in End Balance Guessing competitions.
              </p>
            </div>
          </CardContent>
        </Card>
      </div>
    </div>
  );
}
